import { convertDateToISO } from '../../../../utils/common';

export const initialState = {
  selectededTabValue: 0,
  //orderable
  orderable: {
    // searchbox modal pop up product service name/code api states
    searchProductCodeNameLoading: false,
    searchProductCodeNameResult: [],

    //dropdown servicelevel name api states
    fetchServiceLevelNameLoading: false,
    fetchServiceLevelNameResult: [],

    //delete orderable grid row api
    deleteOrderableLoading: false,
    deleteOrderableResult: [],

    //save  orderable grid data api
    saveOrderableLoading: false,
    saveOrderableResult: false,
    apiResponseStatus: '',

    //get orderable existing data
    fetchOrderableLoading: false,
    fetchOrderableResult: [],
    totalCount: 0,

    //compare data
    fetchOrderableCompareLoading: false,
    fetchOrderableCompareResult: [],
    totalCompareCount: 0,

    //modal open/close state
    openServiceProductModal: false,

    //modal open/close state supported
    openSupportedModal: false,

    //display name on input field states
    codeField: '',
    nameField: '',
    serviceProductField: '',
    serviceLevelId: 0,

    //object for grid & request modal
    orderableGridObject: [
      {
        contractId: 0, //will come from contract story
        erpServiceProductId: 0,
        serviceProductCode: '', //will come from productCode of erpServiceProductId
        serviceProductName: '', //will come from selected row of popupmodal
        servicePriceLevelId: 0,
        serviceOfferingName: '', //will come from selected droopdown of service level
        lastModifiedUserId: 0, //as of now constant 0
        lastModifiedTimestamp: convertDateToISO(),
      },
    ],
    //object for capturing selected row data from modalpopup
    serviceModalData: {
      id: 0,
      erpServiceProductId: 0,
      serviceProductCode: '',
      serviceProductName: '',
    },

    //object for capturing selected row data from service level dropdown
    serviceLevelDropdownData: {
      servicePriceLevelId: 0,
      serviceOfferingName: '',
    },

    gridData: [{}],
    isSet: false,

    //object for api call to save this should create from above object
    saveOrderableObject: [
      {
        contractId: 0, //will come from contract story
        erpServiceProductId: 0, //will come from selected row of popupmodal
        servicePriceLevelId: 0, //will come from selected droopdown of service level
        lastModifiedUserId: 0, //as of now constant 0
        lastModifiedTimestamp: convertDateToISO(), //current date
      },
    ],
    grandparentGridData: [],
  },

  //supported
  supported: {
    fetchSupportedZoneLoading: false,
    fetchSupportedZoneResult: [],
    selectedRows: [],
    isZoneFound: false,

    fetchSupportedLoading: false,
    fetchSupportedResult: [],

    fetchSupportedReq: {
      contractId: 0,
      recordCount: 25,
      pageIndex: 1,
    },
    totalCount: 0,

    fetchOverrideLoading: false,
    overrideData: 'n',
    isOverride: false,
    deleteLoading: false,
    deleteData: false,
    deleteResponse:'',
    requestBody: {
      contractId: 0,
      productCode: '',
      recordCount: 25,
      pageIndex: 1,
    },
  },

  unsupported: {
    isDataFound: false,
    loading: false,
    data: [],
    inputError: null,
    requestBody: {
      contractId: 0,
      productCode: '',
      productName: '',
      recordCount: 25,
      pageIndex: 1,
    },

    searchData: [],
    total: 0,
    loadingSalesOrder: false,
    inputErrorSearchingSalesOrder: [],
    isDataFoundSalesOrder: false,
    addUnsupportedloading: false,
    inputErrorAddUnsupported: [],
    addUnsupportedData: [],
    isDataFoundUnsupported: '',
    reqSearchSalesOrder: {
      productCode: '',
      legacyCode: '',
      name: '',
      pageIndex: 1,
      recordCount: 25,
    },
    alertAdd: '',
    openSalesProductModal: false,
    salesCode: '',
    salesName: '',

    loadingDelete: false,
    inputErrorDelete: null,
    isDataFoundDelete: false,
    deleteData: null,
  },

  salesOrder: {
    isHigherOrderDataFound: false,
    loading: false,
    higherOrderLoading: false,
    salesOrderReportData: [],
    higherSalesOrderReportData: [],
    inputError: null,
    higerOrderInpurtError: null,
    hocSaveResponse: null,
    requestBody: {
      contractId: '',
      contractIgnoreFlag: 'n',
      erpSalesOrderItemId: '',
      salesProduceCode: '',
      salesProductName: '',
      recordCount: 25,
      pageIndex: 1,
    },
    totalHigher: 0,
    totalSales: 0,
  },

  isDataEdited: '',
  noDataToSave: false,
  isOk:false,
  deleteAlert:false
};
